<script lang="ts">
    import vm from '@journeys/Journeys.viewmodel';
    import { JourneyStatus } from '@journeys/Enums';
    import MultiSelect from '@shared/components/MultiSelect/MultiSelect.vue';
    import BSFormInputText from '@shared/components/BSFormInputText.vue';
    import BSFormInputTextarea from '@shared/components/BSFormInputTextarea.vue';
    import ScrollableContainer from '@shared/components/ScrollableContainer.vue';

    const component = {
        name: 'Menu_JourneySettings',
    };

    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    import { inject } from 'vue';
    import { type TagsProvide } from '@shared/components/Tags/Tags.access';
    const tags = inject('tags') as TagsProvide;

    const { activeJourney, account } = vm;
</script>

<template>
    <ScrollableContainer>
        <h2 class="h3">{{ $Resources.JourneySettingsHeading }}</h2>

        <BSFormInputText class="form-group" v-model="activeJourney.Title" :label="$Resources.TitleLabel" :placeholder="$Resources.TitleLabel"></BSFormInputText>

        <div class="form-group">
            <span class="label-look d-block">{{ $Resources.StatusLabel }}:</span>
            <strong>{{ JourneyStatus[activeJourney.Status] }}</strong>
        </div>

        <BSFormInputTextarea
            class="form-group"
            v-model="activeJourney.Description"
            :label="$Resources.DescriptionLabel"
            :placeholder="$Resources.DescriptionLabel"></BSFormInputTextarea>

        <MultiSelect
            class="form-group"
            v-if="tags.state.list.length > 0"
            :loading="!tags.state.loaded"
            :items="tags.state.list"
            :selectedItems="activeJourney.Tags"
            :label="$Resources.TagsLabel"
            displayProp="Title"
            selectProp="TagId"
            @update:selectedItems="(newVal) => (activeJourney.Tags = newVal)"
            @newItem="(newVal) => tags.create(newVal, activeJourney.Tags)"></MultiSelect>
    </ScrollableContainer>
</template>

<style></style>
